import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["error", "className", "title", "customStyles", "caption", "required", "onMenuOpen"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef, useCallback } from "react";
import Select from "react-select";
import ErrorMessage from "./ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const baseCustomStyles = {
  dropdownIndicator: provided => _objectSpread(_objectSpread({}, provided), {}, {
    padding: "4px"
  }),
  indicatorSeparator: provided => _objectSpread(_objectSpread({}, provided), {}, {
    width: "0"
  }),
  IndicatorsContainer: provided => _objectSpread(_objectSpread({}, provided), {}, {
    height: "44px"
  }),
  valueContainer: provided => _objectSpread(_objectSpread({}, provided), {}, {
    height: "44px",
    padding: "0 0 0 14px"
  }),
  placeholder: provided => _objectSpread(_objectSpread({}, provided), {}, {
    marginLeft: "0",
    marginRight: "0",
    color: "#aaa"
  }),
  singleValue: provided => _objectSpread(_objectSpread({}, provided), {}, {
    color: "#444",
    marginLeft: "0",
    marginRight: "0",
    fontSize: "14px"
  }),
  input: provided => _objectSpread(_objectSpread({}, provided), {}, {
    margin: "0",
    paddingBottom: "0px",
    paddingTop: "0px",
    minWidth: "3em",
    color: "#444",
    width: "5em"
  }),
  control: (provided, state) => _objectSpread(_objectSpread({}, provided), {}, {
    border: state.isFocused ? "none" : "none",
    backgroundColor: state.isFocused ? "#e6e6e6" : "#e6e6e6"
  }),
  menu: provided => _objectSpread(_objectSpread({}, provided), {}, {
    color: "#1B1E21",
    zIndex: 1
  })
};
const SelectField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      error,
      className,
      title,
      customStyles = {},
      caption,
      required,
      onMenuOpen
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const selectStyles = Object.assign({}, baseCustomStyles, customStyles);
  const handleMenuOpen = useCallback(() => {
    if (onMenuOpen) {
      onMenuOpen();
    }
    setTimeout(() => {
      const menu = document.querySelector(".react-select__menu-list");
      const selectedEl = document.querySelector(".react-select__option--is-selected");
      if (menu && selectedEl) {
        menu.scrollTo(0, selectedEl.offsetTop);
        selectedEl.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start"
        });
      }
    }, 15);
  }, [onMenuOpen]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, {
        [styles.required]: required
      }),
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.select, className),
      children: /*#__PURE__*/_jsx(Select, _objectSpread({
        styles: selectStyles,
        ref: ref,
        className: "react-select-container",
        classNamePrefix: "react-select",
        required: required,
        isSearchable: false,
        onMenuOpen: handleMenuOpen
      }, _props))
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.caption,
      children: caption
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
});
SelectField.displayName = "SelectField";
export default SelectField;